'use strict';

define([], function() {
  var attributes = {
    byTagName: function(tagName) {
      var tags = [].slice.call(document.getElementsByTagName(tagName));
      for (var i = 0; i < tags.length; i++) {
        var tagObj = {};
        for (var t = 0; t < tags[i].attributes.length; t++) {
          var attr = tags[i].attributes[t];
          tagObj[attr.name] = attr.value;
        }
        tags[i] = tagObj;
      }
      return tags;
    },
  };

  return attributes;
});
